import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink,
} from "shards-react";
import useToken from "shared/hook/useToken";
import ModalLogin from "../ModalLogin/ModalLogin";
import useCurrentUser from "shared/hook/useCurrentUser";
import { removeStoredAuthToken } from "shared/utils/authToken";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const Nav = styled(NavItem)`
  min-width: 120px;
`;

const CustomerName = (props) => {
  const [visible, setVisible] = useState(false);
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const { curruntUser } = useCurrentUser();
  const { token } = useToken();
  const { t, i18n } = useTranslation();
  const toggleUserActions = () => {
    setVisible(!visible);
  };
  const showModalLogin = () => {
    setOpenModalLogin(!openModalLogin);
  };

  const logOut = () => {
    removeStoredAuthToken();
    window.location = "/";
  };
  return (
    <>
      <ToastContainer />
      <Nav tag={Dropdown} caret toggle={toggleUserActions}>
        {token && curruntUser ? (
          <>
            <DropdownToggle
              caret
              tag={NavLink}
              className="text-nowrap px-3"
              style={{ display: "flex", alignItems: "center" }}
            >
              <img
                className="user-avatar rounded-circle mr-2"
                src={require("../../assets/img/avatar.png")}
                alt="User Avatar"
              />{" "}
              <span
                className="d-md-inline-block"
                style={{
                  textOverflow: "ellipsis",
                  overflowX: "hidden",
                  maxWidth: "120px",
                }}
              >
                {curruntUser.user.firstName}
                {/* {curruntUser.user.lastName} */}
              </span>
            </DropdownToggle>
            <Collapse tag={DropdownMenu} right small open={visible}>
              <DropdownItem tag={Link} to="/user-profile">
              {t("common:header.PersonalInformation")}
              </DropdownItem>
              <DropdownItem onClick={logOut}>{t("common:header.LogOut")}</DropdownItem>
            </Collapse>
          </>
        ) : (
          <NavLink onClick={showModalLogin}>
            <img
              className="user-avatar rounded-circle mr-2"
              src={require("../../assets/img/icon_user.png")}
              alt="User icon"
            />
            <span className="d-md-inline-block">
              {t("common:header.Login")}
            </span>
          </NavLink>
        )}
      </Nav>
      <ModalLogin visible={openModalLogin} onCancel={showModalLogin} />
    </>
  );
};
export default CustomerName;
